import {
  FETCH_TOTEM_REPORTS_REQUEST,
  FETCH_TOTEM_REPORTS_SUCCESS,
  FETCH_TOTEM_REPORTS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: {},
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_TOTEM_REPORTS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_TOTEM_REPORTS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_TOTEM_REPORTS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: {},
          error: action.payload,
        },
      }

    default:
      return state
  }
}

export default record
